import { call, put, takeLatest, select } from 'redux-saga/effects'
import actionTypes from '../actions/actionTypes'
import previewDataSelector from '../selectors/preview/dataSelector'
import previewLoader from '../../sync/previewLoader'
import previewActions from '../actions/previewActions'
import { jwtDecode } from 'jwt-decode'

function* getPreviewData(): Generator<any, any, any> {
	// const config = yield call(configLoader.getConfig)
	//    yield put(appActions.configLoaded(config))
	try {
		//TODO: Fix types to remove any
		const data = yield select(previewDataSelector as any)
		const decodedJwt: any = jwtDecode(data.jwt)
		const externalUid = decodedJwt.extra.custom_slide_id
		const previewData = yield call(previewLoader.getSlideData, data.jwt, externalUid)
		yield put(previewActions.previewDataSuccess(previewData.payload.game.activities))
		//state.app.config.session_api_gateway
		return true
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error(err)
	}
}

export { getPreviewData }

export default [takeLatest(actionTypes.PREVIEW_INITIALIZE, getPreviewData)]
